// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:28:53

export default {
  "id": "load-the-dishes-asmr",
  "slug": "load-the-dishes-asmr",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/de4068461ac54cd7aafd6b74af124ed5-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/de4068461ac54cd7aafd6b74af124ed5/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Load The Dishes ASMR",
      "description": "Load The Dishes ASMR is a puzzle game that puts you in comfort and fun! Your task is to sort different colored dishes and put them in the dishwasher. By organizing your cutlery in an organized way, you will find that this is not just a simple puzzle challenge, but also a super\nrelaxing ASMR sound experience.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "colorful",
        "dishes",
        "math"
      ]
    },
    "zh-CN": {
      "title": "摆上餐具 ASMR",
      "description": "《洗餐具ASMR》是一款让你感到舒适和有趣的益智游戏！你的任务是分类不同颜色的餐具并将它们放入洗碗机。通过有条理地整理你的餐具，你会发现这不仅仅是一个简单的益智挑战，而是一次超级放松的ASMR声音体验。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "拼图"
      ],
      "tags": [
        "五彩缤纷",
        "菜肴",
        "数学"
      ]
    },
    "zh-TW": {
      "title": "將餐具装入 ASMR",
      "description": "載入餐具ASMR 是一款讓你感到舒適與愉快的益智遊戲！你的任務是分類不同顏色的餐具並將其放入洗碗機。通過有條理地整理你的餐具，你會發現這不僅是一個簡單的益智挑戰，同時也是一種超級放鬆的ASMR聲音體驗。",
      "instructions": "滑鼠點擊或觸控玩遊戲",
      "genres": [
        "謎題"
      ],
      "tags": [
        "colorful",
        "色彩豐富，dishes，菜色，math，數學"
      ]
    },
    "zh-HK": {
      "title": "載入碗碟 ASMR",
      "description": "載入餐具ASMR是一款讓你感到舒適及樂趣的益智遊戲！你的任務是分類不同顏色的餐具並將其放入洗碗機。透過有系統地整理你的餐具，你會發現這不僅是一個簡單的益智挑戰，同時也是一種超級放鬆的ASMR聲音體驗。",
      "instructions": "滑鼠點擊或觸控開始遊戲",
      "genres": [
        "謎題"
      ],
      "tags": [
        "色彩",
        "佳肴",
        "數學"
      ]
    },
    "ja": {
      "title": "皿をセットするASMR",
      "description": "ディッシュ・ロード・ASMRは、快適で楽しいパズルゲームです！あなたのタスクは、異なる色のディッシュを整頓し、洗濯機に入れることです。お皿を整然と並べることで、これは単なるパズルチャレンジではなく、非常にリラックスできるASMR音体験であることがわかります。",
      "instructions": "マウスクリックまたはタップして遊ぶ",
      "genres": [
        "パズル"
      ],
      "tags": [
        "カラフルな料理",
        "数学"
      ]
    },
    "ko": {
      "title": "도시리를 로드하세요 ASMR",
      "description": "불러서 식기 ASMR는 편안함과 재미를 제공하는 퍼즐 게임입니다! 당신의 작업은 다양한 색상의 식기를 정리하고 세척기에 넣는 것입니다. 도구를 정리하는 것을 통해 이것이 단순한 퍼즐 도전이 아니라, 매우 편안한 ASMR 사운드 경험임을 깨닫게 됩니다.",
      "instructions": "마우스 클릭 또는 탭하여 플레이하세요.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "다채로운",
        "料理",
        "수학"
      ]
    },
    "fr": {
      "title": "Charger les assiettes ASMR",
      "description": "Charger les Assiettes ASMR est un jeu de puzzle qui vous met dans un cadre de confort et de divertissement ! Votre tâche est de trier les assiettes de différentes couleurs et de les mettre dans le lave-vaisselle. En organisant votre vaisselle de manière ordonnée, vous découvrirez que ce n'est pas seulement un défi de puzzle simple, mais aussi une expérience de sons ASMR super apaisante.",
      "instructions": "Clic ou appui sur l'écran pour jouer",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "coloré",
        "plats",
        "mathématiques"
      ]
    }
  }
};
